import React from "react";
import ReactDOM from "react-dom/client";
import "./index.scss";
import App from "./App";
import GTM from "./GTM";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { store } from "store";
import i18next from "i18next";
import { I18nextProvider } from "react-i18next";
import {
  global_en,
  global_es,
  global_fr,
  global_it,
  global_nl,
  global_de,
} from "translations";
import { GoogleOAuthProvider } from "@react-oauth/google";


const root = ReactDOM.createRoot(document.getElementById("root"));

i18next.init({
  interpolation: { escapeValue: false },
  lng: "en",
  fallbackLng: "en",
  resources: {
    en: {
      global: global_en,
    },
    uk: {
      global: global_en,
    },
    fr: {
      global: global_fr,
    },
    be: {
      global: global_fr,
    },
    es: {
      global: global_es,
    },
    it: {
      global: global_it,
    },
    ge: {
      global: global_de,
    },
  },
});
root.render(
  <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>

  <BrowserRouter>
    {/* <React.StrictMode> */}
      <I18nextProvider i18n={i18next}>
        <Provider store={store}>
          <App />
        </Provider>
      </I18nextProvider>
    {/* </React.StrictMode> */}
  </BrowserRouter>
  </GoogleOAuthProvider>,

);
